import { SectionContainer } from 'pages/requestList/components/SectionContainer/SectionContainer';
import styled from 'styled-components';

export const StyledSectionContainer = styled(SectionContainer)`
    margin-bottom: 15px;
`;
